import React from 'react';
import { render } from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import 'normalize.css';
import { store, history } from './store';
import theme from './theme';
// import './bootstrap.css';
import './index.css';
import 'noty/lib/noty.css';
import 'noty/lib/themes/metroui.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
